import { Stack, styled, Typography, useTheme } from "@mui/material";
import { ProductPackaging } from "src/api/client-api/products/useGetOneProduct";
import { useFoodpilotContext } from "src/context/FoodpilotContext";
import { URLHandler } from "src/services/URLHandler";
import { FoodsIcon } from "@foodpilot/foods";
import { NavLink } from "react-router";
import { useTranslation } from "react-i18next";
import { canOpenLineItem } from "src/pages/Product/lineItemAccess";

type PackagingDataRowProps = {
    productPackaging: ProductPackaging;
};

const StyledNavLink = styled(NavLink)(({ theme }) => ({
    color: theme.palette.text.primary,
    textDecoration: "none",
    padding: 0,
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
}));

export const PackagingsDataRow = (props: PackagingDataRowProps) => {
    const { productPackaging } = props;
    const { selectedCompany } = useFoodpilotContext();
    const theme = useTheme();
    const { t } = useTranslation();

    const packaging = productPackaging.packaging;
    if (packaging === undefined || packaging === null) {
        return null;
    }

    const scoresUrl = URLHandler.packaging.scores(selectedCompany?.id ?? 0, packaging.id);

    return (
        <Stack direction="row" justifyContent="space-between" alignItems="center" gap={2}>
            <Stack flex={3}>
                <Typography variant="h4">{packaging.name}</Typography>
                <Stack direction="row" alignItems="center" gap={1} color={theme.palette.text.secondary}>
                    <Typography variant="small-bold" color={theme.palette.text.secondary}>
                        {`${t("packagings.form.quantity", "Quantity")}: ${productPackaging.quantity ?? 1}`}
                    </Typography>
                </Stack>
            </Stack>

            <Stack flex={1} alignItems="flex-end">
                {canOpenLineItem(packaging) && (
                    <StyledNavLink to={scoresUrl} target="_blank">
                        <FoodsIcon icon="openNewTab" size={3} />
                    </StyledNavLink>
                )}
            </Stack>
        </Stack>
    );
};
